import { Component, OnInit } from '@angular/core';
import { StatefulComponent } from '../../components/stateful/stateful.component';
import { setContainerTypeAction } from '../../ngrx/actions/global.actions';

@Component({
  selector: 'app-registration-landing',
  templateUrl: './registration-landing.component.html',
  styleUrls: ['./registration-landing.component.scss'],
  standalone: true,
  imports: []
})
export class RegistrationLandingComponent extends StatefulComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    this.dispatch(setContainerTypeAction({ containerType: 'normal' }));
  }
}
